import { getCheckoutClient } from "../config/CheckoutClient";
import { selectStripePaymentIntentMinorAmount } from '../selectors/paymentPlans';
import { GATEWAY_TYPE_STRIPE } from '@showclix-shared/Payment/constants/gatewayTypes';
import { updateStripePaymentIntent } from './payment';

export const setPaymentPlansDynamicData = (data) => {
    return {
        type: 'SET_PAYMENT_PLANS_DYNAMIC_DATA',
        data,
    }
}

export const setPaymentPlan = (paymentPlanId) => {
    return {
        type: 'SELECT_PAYMENT_PLAN',
        paymentPlanId,
    }
}

export function fetchPaymentPlans(token, secret) {
    return (dispatch, getState) => {
        let state = getState();
        return getCheckoutClient(state.ui.apiUrl).reservationGetRequest(token, 'payment-plans', secret).then((result) => {
            if (result?.ok && result.body?.paymentPlans) {
                dispatch(setPaymentPlansDynamicData(result.body.paymentPlans));
                return result.body.paymentPlans;
            }
            return Promise.reject(new Error('fetchPaymentPlans failed'));
        });
    }
}

/**
 * Refreshes installment amounts from the server, then returns the minor-unit amount
 * that must be used for Stripe PaymentIntent create/update (matches verifyAmountDue).
 */
export function refreshPaymentPlansForStripeIntent() {
    return async (dispatch, getState) => {
        const { token, secret } = getState().reservation;
        await dispatch(fetchPaymentPlans(token, secret));
        return selectStripePaymentIntentMinorAmount(getState());
    };
}

/**
 * Refreshes payment-plan installment amounts after the reservation total changes
 * (cart edits, insurance, loyalty). Updates Stripe PI when on Stripe checkout.
 */
export function refreshPaymentPlansAfterCartChange() {
    return async (dispatch, getState) => {
        const { token, secret } = getState().reservation;
        if (!token || !secret) {
            return;
        }

        const gatewayType = getState().payment.gatewayType;

        try {
            await dispatch(fetchPaymentPlans(token, secret));
        } catch (err) {
            console.warn('refreshPaymentPlansAfterCartChange failed', err);
            return;
        }

        if (+gatewayType === GATEWAY_TYPE_STRIPE) {
            const piAmount = selectStripePaymentIntentMinorAmount(getState());
            const { stripePaymentIntentId, stripePaymentIntentSecret } = getState().payment;
            if (stripePaymentIntentId && stripePaymentIntentSecret) {
                await dispatch(
                    updateStripePaymentIntent(piAmount, {
                        payment_intent_id: stripePaymentIntentId,
                        client_secret: stripePaymentIntentSecret,
                    }),
                );
            }
        }
    };
}
